import {
  ADMIN_USER_FETCH_ALL,
  ADMIN_USER_FETCH_ALL_SUCCESS,
  ADMIN_USER_FETCH_ALL_FAIL,
  ADMIN_USER_MARK_FETCHING,
  ADMIN_USER_FETCH_SUCCESS,
  ADMIN_USER_FETCH_FAIL,
  ADMIN_USER_ADD,
  ADMIN_USER_ADD_SUCCESS,
  ADMIN_USER_ADD_FAIL,
  ADMIN_USER_UPDATE,
  ADMIN_USER_UPDATE_SUCCESS,
  ADMIN_USER_UPDATE_FAIL,
  ADMIN_USER_DELETE,
  ADMIN_USER_DELETE_SUCCESS,
  ADMIN_USER_DELETE_FAIL,
  ADMIN_USER_SET_SORT,
  ADMIN_USER_SET_PAGE,
  ADMIN_USER_SET_PAGE_SIZE
} from './constants';
import { createSelector } from 'reselect';
import { filterItemsFunctionCreator } from '../util/filterItems';
import {
  getFilterAttribute,
  getFilterOperator,
  getFilterValue
} from '../filterSelectors';
import { getOrgsObj } from '../orgAdmin/reducer';
import { USER_LOGIN_SUCCESS, USER_LOGOUT } from '../../user/constants';
import {
  ADMIN_SET_FILTER_ATTR,
  ADMIN_SET_FILTER_OPERATOR,
  ADMIN_SET_FILTER_VALUE
} from '../constants';
import { getUserEmail } from '../../util/jwt';

const initialState = {
  fetching: false,
  currentlyFetching: {},
  fetched: false,
  users: {},
  currentUser: {},
  sortAttribute: 'name',
  sortAttributeInverted: false,
  page: 1,
  pageSize: 20
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return { ...state, currentUser: action.data };
    case USER_LOGOUT:
      return { ...initialState, currentUser: {} };
    case ADMIN_USER_FETCH_ALL:
      return { ...state, fetching: true };
    case ADMIN_USER_FETCH_ALL_SUCCESS: {
      const users = {};
      let currentUser = state.currentUser;
      if (Object.keys(currentUser).length === 0) {
        currentUser = null;
      }
      const currentUserEmail = getUserEmail();
      action.users.forEach(user => {
        users[user.id] = user;
        users[user.id].saved = true;
        if (!currentUser) {
          if (user.email === currentUserEmail) {
            currentUser = user;
          }
        }
      });
      return { ...state, fetching: false, fetched: true, users, currentUser };
    }
    case ADMIN_USER_FETCH_ALL_FAIL:
      return { ...state, fetching: false };
    case ADMIN_USER_MARK_FETCHING: {
      const currentlyFetching = { ...state.currentlyFetching };
      currentlyFetching[action.userId] = true;
      return { ...state, currentlyFetching };
    }
    case ADMIN_USER_FETCH_SUCCESS: {
      const users = JSON.parse(JSON.stringify(state.users));
      users[action.user.id] = action.user;
      users[action.user.id].saved = true;
      const currentlyFetching = { ...state.currentlyFetching };
      delete currentlyFetching[action.user.id];
      let currentUser = state.currentUser;
      if (Object.keys(currentUser).length === 0) {
        currentUser = null;
        const currentUserEmail = getUserEmail();
        console.log('currentUserEmail (FETCH_SUCCESS)', currentUserEmail);
        if (action.user.email === currentUserEmail) {
          currentUser = action.user;
        }
      }
      return { ...state, users, currentlyFetching, currentUser };
    }
    case ADMIN_USER_FETCH_FAIL: {
      const currentlyFetching = { ...state.currentlyFetching };
      delete currentlyFetching[action.userId];
      return { ...state, currentlyFetching };
    }
    case ADMIN_USER_ADD: {
      const users = JSON.parse(JSON.stringify(state.users));
      users[action.user.id] = action.user;
      users[action.user.id].saving = true;
      return { ...state, users };
    }
    case ADMIN_USER_ADD_SUCCESS: {
      const users = JSON.parse(JSON.stringify(state.users));
      delete users[action.user.id].saving;
      users[action.user.id].saved = true;
      return { ...state, users };
    }
    case ADMIN_USER_ADD_FAIL: {
      const users = JSON.parse(JSON.stringify(state.users));
      delete users[action.user.id].saving;
      delete users[action.user.id].saved;
      return { ...state, users };
    }
    case ADMIN_USER_UPDATE: {
      const users = JSON.parse(JSON.stringify(state.users));
      users[action.user.id] = action.user;
      users[action.user.id].saving = true;
      return { ...state, users };
    }
    case ADMIN_USER_UPDATE_SUCCESS: {
      const users = JSON.parse(JSON.stringify(state.users));
      users[action.user.id].saved = true;
      delete users[action.user.id].saving;
      return { ...state, users };
    }
    case ADMIN_USER_UPDATE_FAIL: {
      const users = JSON.parse(JSON.stringify(state.users));
      delete users[action.user.id].saving;
      return { ...state, users };
    }
    case ADMIN_USER_DELETE: {
      const users = JSON.parse(JSON.stringify(state.users));
      delete users[action.user.id];
      return { ...state, users };
    }
    case ADMIN_USER_DELETE_SUCCESS:
      return state;
    case ADMIN_USER_DELETE_FAIL: {
      const users = JSON.parse(JSON.stringify(state.users));
      users[action.user.id] = action.user;
      return { ...state, users };
    }
    case ADMIN_USER_SET_SORT: {
      const sortAttributeInverted =
        state.sortAttribute === action.sort ?
          !state.sortAttributeInverted : false;
      return { ...state, sortAttribute: action.sort, sortAttributeInverted };
    }
    case ADMIN_USER_SET_PAGE:
      return { ...state, page: action.page };
    case ADMIN_USER_SET_PAGE_SIZE:
      return { ...state, pageSize: action.size };
    case ADMIN_SET_FILTER_ATTR:
      return { ...state, page: 1 };
    case ADMIN_SET_FILTER_OPERATOR:
      return { ...state, page: 1 };
    case ADMIN_SET_FILTER_VALUE:
      return { ...state, page: 1 };
  }
  return state;
};

const fetching = state => state.userAdmin.fetching;
const fetched = state => state.userAdmin.fetched;
const users = state => state.userAdmin.users;
const sortAttribute = state => state.userAdmin.sortAttribute;
const sortAttributeInverted = state => state.userAdmin.sortAttributeInverted;
const page = state => state.userAdmin.page;
const pageSize = state => state.userAdmin.pageSize;
const currentlyFetching = state => state.userAdmin.currentlyFetching;
const currentUser = state => state.userAdmin.currentUser;

export const getCurrentUser = createSelector(
  // possible duplicate of getLoggedInUser from /src/js/user/reducer.js
  // currentUser, user => user
  currentUser, user => {
    console.log('selector reducer');
    return user;
  }
);

export const getUserPage = createSelector(
  page, page => page
);

export const getUserPageSize = createSelector(
  pageSize, size => size
);

export const isFetchingUsers = createSelector(
  fetching, fetching => fetching
);

export const hasFetchedUsers = createSelector(
  fetched, fetched => fetched
);

export const getSavedUsers = createSelector(
  users, users => Object.values(users).filter(user => user.saved)
);

export const getUsersWithOrgs = createSelector(
  [getOrgsObj, getSavedUsers], (orgsObj, users) => {
    return users.map(user => {
      const orgs = [];
      if (user.orgIds && Array.isArray(user.orgIds) && user.orgIds.length) {
        for (let i = 0; i < user.orgIds.length; i++) {
          const id = user.orgIds[i];
          if (orgsObj[id] && orgsObj[id].name) {
            orgs.push(orgsObj[id].name);
          }
        }
      }
      return { ...user, orgs };
    });
  }
);

const filterItems = filterItemsFunctionCreator([
  { attribute: 'name', operator: 'contains' },
  { attribute: 'email', operator: 'contains' },
  { attribute: 'orgs', operator: 'includes' }
]);

export const getFilteredUsers = createSelector(
  [getUsersWithOrgs, getFilterAttribute, getFilterOperator, getFilterValue],
  filterItems
);

export const getSortedUsers = createSelector(
  [getFilteredUsers, sortAttribute, sortAttributeInverted],
  (users, attribute, inverted) => {
    return [ ...users ].sort((a, b) => {
      if (a[attribute] < b[attribute]) return inverted ? 1 : -1;
      if (a[attribute] > b[attribute]) return inverted ? -1 : 1;
      return 0;
    });
  }
);

export const getPageOfUsers = createSelector(
  [getSortedUsers, page, pageSize], (users, page, size) => {
    const start = (page - 1) * size;
    const end = page * size;
    return users.slice(start, end);
  }
);

export const getUsersObj = createSelector(
  users, users => users
);

export const getUserCount = createSelector(
  getFilteredUsers, users => users.length
);

export const getUserSortAttribute = createSelector(
  sortAttribute, sort => sort
);

export const getUserSortAttributeInverted = createSelector(
  sortAttributeInverted, inverted => inverted
);

export const getCurrentlyFetchingUsers = createSelector(
  currentlyFetching, currentlyFetching => currentlyFetching
);

export default reducer;
